@@ -0,0 +1,366 @@
<template>
<div class="div1">
<div class="container">
	<div class="d-flex justify-content-center h-100">
        
		<div class="card">
			<div class="card-header">
                 <img class="dinet-logo" src="/static/img/dinet.png">
				 <h3 class="acces-title"><i class = "login-logo"></i>Iniciar Sesión</h3>
				
			</div>
			<div class="card-body">
				 <form @submit.prevent="handleSubmit">
                   <fieldset>
                  <div class="form-group col-md-12">
                     <label>Usuario</label>
                     <input type="text" v-model="Username" class="form-control" placeholder="Usuario" :class="{ 'is-invalid': submitted && !Username }" maxlength="20">
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">

                     <label>Contraseña</label>
                     <input type="Password" v-model="Password" name="Password" placeholder="Contraseña" class="form-control"  :class="{ 'is-invalid': submitted && !Password }" maxlength="100">
                    <div v-show="!submitted && message" class="invalid-feedback" style="padding-top:5%">{{message}}</div>
                    <div style="text-align:right; padding-top:10px">
                      <button v-bind:class="['btn btn-sm btn-success btnAction btn-login']" style="padding-right:10px; width:107px !important" value="Iniciar sesión"><span style="position:relative; left:-2px">Iniciar sesión</span></button>
                    </div>

                    </div>
                  </div>
              </fieldset>
            </form>
			</div>
		</div>
	</div>
</div>
</div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login2',
  data () {
    return {
      Username: '',
      Password: '',
      submitted: false,
      message: ''
    }
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'userDefaultMenu',
      'userInfo'
    ])
  },
  created () {
  },
  methods: {
    ...mapActions([
      'logIn',
      'fetchUserInfo',
      'fetchUserClients'
    ]),
    handleSubmit () {
      document.activeElement.blur()
      this.submitted = true
      if (this.Username && this.Password) {
        let loader = this.$loading.show({
          loader: 'dots'
        })

        let parameters = {
          Username: this.Username.toUpperCase(),
          Password: this.Password
        }

        this.logIn(parameters).then(() => {
          this.submitted = false
          this.message = ''

          if (this.loggedIn) {
            this.$router.go({ name: this.userDefaultMenu.permission })
          } else {
            this.message = 'Usuario y/o contraseña incorrecto'
            loader.hide()
          }
        })
      } else if (!this.Username || !this.Password) {
        this.submitted = false
        this.message = 'Usuario y/o contraseña incorrecto'
      }
    }
  }
}
</script>

<style>

.dinet-logo{
  height: 200px;
  margin-left: 20%;
  position: relative;
}

.panel > .panel-heading {
    background-image: none !important;
    color: white !important;
}

.invalid-feedback {
  color: red
}

.main-head{
    height: 150px;
    background: #FFF;
}

.login-side {
  width: 65% !important;
  height: 100%;
  background-image: url("/static/img/login_op.jpg");
  background-size: cover;
  overflow-x: hidden;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
}

.login-form{
  margin-top: 8%;
  margin-left: 20%;
}

.register-form{
  margin-top: 20%;
}

.login-main-text{
  margin-top: 20%;
  padding: 60px;
  color: #fff;
}

.login-main-text h2{
  font-weight: 300;
}

.btn-black{
  background-color: #000 !important;
  color: #fff;
}

.title-vitz{
  margin-top: 8%;
  color: #364A5D;	
  font-size: 30px;	
  font-weight: 600;	
  letter-spacing: -0.77px;	
  line-height: 44px;
  padding-left: 30%;
}

.acces-title{
  color: #444444;
  font-size: 20px;	
  font-weight: 550;	
  letter-spacing: -0.77px;
  text-transform: uppercase;
  padding-left: 17px;
}

.login-logo::before{
  padding-right: 5%;
  position: relative;
  top: 2px;
  content: url("/static/img/icons/sign-in-alt-solid.png");
}

.form-user{
  padding-top: 5%;
}

.form-user{
  width: 80%;
}

.form-pass{
  width: 80%;
}

.form-pass{
  padding-bottom: 20px;  
}

.btn-login{
  margin-left: 57.5%;
  height: 48px;	
  margin-top: 5px;
  text-align: right;
}

/* Prueba */

.div1{
background-image: url("/static/img/login_op.jpg");
background-size: cover;
background-repeat: no-repeat;
height: 100%;
width: 100%;
position: fixed;
}

.container{
height: 100%;
align-content: center;
}

.container {
width: 100%;
padding-right: 15px;
padding-left: 15px;
margin-right: auto;
margin-left: auto;
}

.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.container {
    height: 100%;
    -ms-flex-line-pack: center;
    align-content: center;
}

.container {
    height: 100%;
    -ms-flex-line-pack: center;
    align-content: center;
}

.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
.container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}

.h-100 {
    height: 100%!important;
}
.justify-content-center {
    -ms-flex-pack: center!important;
    justify-content: center!important;
}
.d-flex {
    display: -ms-flexbox!important;
    display: flex!important;
}

.card{
height: 570px;
width: 400px;
padding: 20px;
background-color: white;
margin-top: auto;
margin-bottom: auto;
box-shadow: 0 1px 1px rgba(0,0,0,0.1) !important;
border-radius: 10px !important;
border: 1px solid #E3E3E3 !important;
}

.card-header{
border-bottom: 0;
background-color: white;

}

.input-group-prepend span{
width: 50px;
background-color: #FFC312;
color: black;
border:0 !important;
}

input:focus{
outline: 0 0 0 0  !important;
box-shadow: 0 0 0 0 !important;

}

.remember{
color: white;
}

.remember input
{
width: 20px;
height: 20px;
margin-left: 15px;
margin-right: 5px;
}

.login_btn{
color: black;
background-color: #FFC312;
width: 100px;
}

.login_btn:hover{
color: black;
background-color: white;
}

.links{
color: white;
}

.links a{
margin-left: 4px;
}
/* Fin Prueba  */

@media (max-width: 578px) {
    .div1{
       background-color: white !important;
       background-image: none !important;
        background-size: cover;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
        font-family: 'Numans', sans-serif;
        position: fixed;
        }

    .card{
        height: 570px;
        width: 400px;
        padding: 20px;
        background-color: white;
        margin-top: auto;
        margin-bottom: auto;
        box-shadow: 0 0px 0px rgba(0,0,0,0.1) !important;
        border: 0 !important;
    }

}

</style>



// WEBPACK FOOTER //
// Login2.vue?bd9a2c48